module.exports = __webpack_public_path__ + "img/s1_m_img.60b0dc12.png";